import actionTypes from "../redux/actionTypes";
export const buildGetDocumentTableDataScope = (documentId) => `${actionTypes.GET_DOCUMENT_TABLE_DATA}_${documentId}`;
